<template>
  <div class="container flex-column flex-justify-start flex-align-center">
    <div class="data-sample flex-column flex-justify-start flex-align-start" v-if="subindex==1">
      <div class="data-search flex-wrap flex-justify-start flex-align-start">
        <div class="ds-item flex-row flex-justify-start flex-align-center">
          <div class="dsi-text">开始日期：</div>
          <el-date-picker
            v-model="mainpage.startTime"
            type="date"
            placeholder="选择日期"
            style="width: 250px">
          </el-date-picker>
        </div>
        <div class="ds-item flex-row flex-justify-start flex-align-center">
          <div class="dsi-text">结束日期：</div>
          <el-date-picker
            v-model="mainpage.endTime"
            type="date"
            placeholder="选择日期"
            style="width: 250px">
          </el-date-picker>
        </div>
        <div class="ds-item flex-row flex-justify-start flex-align-center">
          <div class="dsi-text">抄表类型：</div>
          <el-select v-model="mainpage.form.sampletype" placeholder="请选择" style="width: 250px">
            <el-option
              v-for="item in mainpage.options.sampletype"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="ds-item flex-row flex-justify-start flex-align-center">
          <div class="dsi-text">设备类型：</div>
          <el-select v-model="mainpage.form.devtype" placeholder="请选择" style="width: 250px">
            <el-option
              v-for="item in mainpage.options.devtype"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="ds-item flex-row flex-justify-start flex-align-center">
          <div class="dsi-text">设备名称或编号：</div>
          <el-input v-model="mainpage.form.sn" placeholder="设备名称或编号" style="width: 250px"></el-input>
        </div>
        <div class="ds-item flex-row flex-justify-start flex-align-center">
          <div class="dsi-text">所属厂区：</div>
          <el-select v-model="mainpage.form.changqu" placeholder="请选择" @change="handleChangqu" style="width: 250px">
            <el-option
              v-for="item in mainpage.options.changqu"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="ds-item flex-row flex-justify-start flex-align-center">
          <div class="dsi-text">所属楼号：</div>
          <el-select v-model="mainpage.form.louhao" placeholder="请选择" @change="handleLouhao" style="width: 250px">
            <el-option
              v-for="item in mainpage.options.louhao"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="ds-item flex-row flex-justify-start flex-align-center">
          <div class="dsi-text">所属楼层：</div>
          <el-select v-model="mainpage.form.louceng" placeholder="请选择" style="width: 250px">
            <el-option
              v-for="item in mainpage.options.louceng"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="ds-item flex-row flex-justify-start flex-align-center">
          <div class="dsi-text">所属公司：</div>
          <el-select v-model="mainpage.form.company" placeholder="请选择" style="width: 250px">
            <el-option
              v-for="item in mainpage.options.company"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="ds-item flex-row flex-justify-start flex-align-center">
          <el-button type="success" icon="el-icon-search" style="font-size: 14px; padding: 11px;" @click="hadleMainSearch">查询</el-button>
          <el-button type="success" icon="el-icon-plus" style="font-size: 14px; padding: 11px;" @click="changeSubindex(2)">手工录入</el-button>
          <el-button type="success" icon="el-icon-upload" style="font-size: 14px; padding: 11px;" @click="saveSample">导出EXCEL</el-button>
        </div>
      </div>
      <div class="data-display flex-column flex-justify-start flex-align-center">
        <div class="data-bs">
          <el-button type="success" icon="el-icon-search" style="font-size: 14px; padding: 11px;margin-left: 20px;" @click="changeSubindex(4)">能耗统计</el-button>
        </div>
        <div class="gird-area flex-row flex-justify-start flex-align-start">
          <el-table :data="mainpage.tableData" :header-cell-style="{'text-align': 'center', 'background-color': '#f5fafe'}" :cell-style="{'text-align': 'center'}" border style="width: 100%;">
            <el-table-column fixed prop="id" label="序号" width="50"></el-table-column>
            <el-table-column prop="sn" label="设备编号" width="200"></el-table-column>
            <el-table-column prop="name" label="设备名称" width="200"></el-table-column>
            <el-table-column prop="devtype" label="设备类型" width="100"></el-table-column>
            <el-table-column prop="lastvalue" label="上次抄表数" width="100"></el-table-column>
            <el-table-column prop="thisvalue" label="本次抄表数" width="100"></el-table-column>
            <el-table-column prop="usevalue" label="本次用量" width="100"></el-table-column>
            <el-table-column prop="location" label="安装位置"></el-table-column>
            <el-table-column prop="company" label="所属公司(占比)"></el-table-column>
            <el-table-column prop="datetime" label="抄表时间" width="200"></el-table-column>
            <el-table-column prop="paratype" label="抄表类型" width="100"></el-table-column>
            <el-table-column prop="parafrom" label="抄表人" width="100"></el-table-column>
            <el-table-column label="操作" width="100"></el-table-column>
          </el-table>
        </div>
        <div class="data-page flex-row flex-justify-end flex-align-start">
          <el-pagination
            background
            layout="prev, pager, next"
            :total="mainpage.form.totalpage"
            :current-page.sync="mainpage.form.currpage"
            :page-size="mainpage.form.pagesize"
            @current-change="handleMainPage">
          </el-pagination>
        </div>
      </div>
    </div>
    <div class="data-sample flex-column flex-justify-start flex-align-start" v-if="subindex==2">
      <div class="hhead flex-row flex-justify-start flex-align-center" style="margin-top: 10px;">
        <div class="hheadl flex-row flex-justify-start flex-align-start">新增手工录入</div>
        <div class="hheadr flex-row flex-justify-end flex-align-start">
          <i class="el-icon-close" style="font-size: 16px; cursor: pointer;" @click="changeSubindex(1)"></i>
        </div>
      </div>
      <div class="luru-display flex-column flex-justify-start flex-align-center">
        <div class="gird-area flex-row flex-justify-center flex-align-start">
          <el-form label-position="right" label-width="150px">
            <el-form-item label="设备编号：">
              <el-input v-model="manualpage.form.sn" :disabled="true" style="width: 600px;"></el-input>
            </el-form-item>
            <el-form-item label="设备名称：">
              <el-input v-model="manualpage.form.name" :disabled="true" style="width: 600px;"></el-input>
            </el-form-item>
            <el-form-item label="设备类型：">
              <el-input v-model="manualpage.form.devtype" :disabled="true" style="width: 600px;"></el-input>
            </el-form-item>
            <el-form-item label="安装位置：">
              <el-input v-model="manualpage.form.location" :disabled="true" style="width: 600px;"></el-input>
            </el-form-item>
            <el-form-item label="表具数值：">
              <el-input v-model="manualpage.form.value" style="width: 600px;"></el-input>
            </el-form-item>
            <el-form-item label="抄表人：">
              <el-input v-model="manualpage.form.manualuser" :disabled="true" style="width: 600px;"></el-input>
            </el-form-item>
            <el-form-item label="抄表时间：">
              <el-input v-model="manualpage.form.datetime" :disabled="true" style="width: 600px;"></el-input>
            </el-form-item>
            <el-form-item>
              <div style="text-align: right;width: 100%;">
                <el-button type="primary" @click="handleAddSg">保存</el-button>
                <el-button type="primary" @click="changeSubindex(1)">取消</el-button>
              </div>
            </el-form-item>
          </el-form>
          <el-button type="primary" style="font-size: 14px; padding: 11px;margin-left: 20px;" @click="changeSubindex(3)">选择录入设备</el-button>
        </div>
      </div>
    </div>
    <div class="data-sample flex-column flex-justify-start flex-align-start" v-if="subindex==3">
      <div class="hhead flex-row flex-justify-start flex-align-center" style="margin-top: 10px;">
        <div class="hheadl flex-row flex-justify-start flex-align-start">选择录入设备</div>
        <div class="hheadr flex-row flex-justify-end flex-align-start">
          <i class="el-icon-close" style="font-size: 16px; cursor: pointer;" @click="changeSubindex(2)"></i>
        </div>
      </div>
      <div class="data-search flex-wrap flex-justify-start flex-align-start">
        <div class="ds-item flex-row flex-justify-start flex-align-center">
          <div class="dsi-text">所属厂区：</div>
          <el-select v-model="shebeipage.form.changqu" placeholder="请选择" @change="handleChangqu" style="width: 250px">
            <el-option
              v-for="item in mainpage.options.changqu"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="ds-item flex-row flex-justify-start flex-align-center">
          <div class="dsi-text">所属楼号：</div>
          <el-select v-model="shebeipage.form.louhao" placeholder="请选择" @change="handleLouhao" style="width: 250px">
            <el-option
              v-for="item in mainpage.options.louhao"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="ds-item flex-row flex-justify-start flex-align-center">
          <div class="dsi-text">所属楼层：</div>
          <el-select v-model="shebeipage.form.louceng" placeholder="请选择" style="width: 250px">
            <el-option
              v-for="item in mainpage.options.louceng"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="ds-item flex-row flex-justify-start flex-align-center">
          <div class="dsi-text">设备类型：</div>
          <el-select v-model="shebeipage.form.devtype" placeholder="请选择" style="width: 250px">
            <el-option
              v-for="item in shebeipage.options.devtype"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="ds-item flex-row flex-justify-start flex-align-center">
          <div class="dsi-text">设备名称或编号：</div>
          <el-input v-model="shebeipage.form.sn" placeholder="设备名称或编号" style="width: 250px;"></el-input>
        </div>
        <div class="ds-item flex-row flex-justify-start flex-align-center">
          <el-button type="success" icon="el-icon-search" style="font-size: 14px; padding: 11px;" @click="handleShebeiSearch">查询</el-button>
        </div>
      </div>
      <div class="luru-display flex-column flex-justify-start flex-align-center" style="margin-top: 20px;">
        <div class="gird-area flex-row flex-justify-center flex-align-start">
          <el-table :data="shebeipage.tableData" :header-cell-style="{'text-align': 'center', 'background-color': '#f5fafe'}" :cell-style="{'text-align': 'center'}" border style="width: 100%;">
            <el-table-column fixed prop="id" label="序号" width="50"></el-table-column>
            <el-table-column prop="sn" label="设备编号"></el-table-column>
            <el-table-column prop="name" label="设备名称"></el-table-column>
            <el-table-column prop="devtype" label="设备类型"></el-table-column>
            <el-table-column prop="location" label="安装位置"></el-table-column>
            <el-table-column label="操作" width="100">
              <template slot-scope="scope">
                <el-tooltip effect="light" content="选择设备" placement="top-start">
                  <i class="el-icon-check" @click="handleCheck(scope.row)" style="cursor: pointer; font-size: 18px;"></i>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="data-page flex-row flex-justify-end flex-align-start">
          <el-pagination
            background
            layout="prev, pager, next"
            :total="shebeipage.form.totalpage"
            :current-page.sync="shebeipage.form.currpage"
            :page-size="shebeipage.form.pagesize"
            @current-change="handleShebeiPage">
          </el-pagination>
        </div>
      </div>
    </div>
    <div class="data-sample flex-column flex-justify-start flex-align-start" v-if="subindex==4">
      <div class="hhead flex-row flex-justify-start flex-align-center" style="margin-top: 10px;">
        <div class="hheadl flex-row flex-justify-start flex-align-start">能耗统计</div>
        <div class="hheadr flex-row flex-justify-end flex-align-start">
          <i class="el-icon-close" style="font-size: 16px; cursor: pointer;" @click="changeSubindex(1)"></i>
        </div>
      </div>
      <div class="luru-display flex-column flex-justify-start flex-align-center">
        <div style="width: 100%;text-align: left;padding-left: 20px;padding-top: 20px;">
          <el-button type="success" icon="el-icon-upload" style="font-size: 14px; padding: 11px;" @click="saveTongji">导出EXCEL</el-button>
        </div>
        <div class="gird-area flex-row flex-justify-center flex-align-start">
          <el-table :data="tongjipage.tableData" :header-cell-style="{'text-align': 'center', 'background-color': '#f5fafe'}" :cell-style="{'text-align': 'center'}" border style="width: 100%;">
            <el-table-column fixed prop="id" label="序号" width="50"></el-table-column>
            <el-table-column prop="sn" label="设备编号"></el-table-column>
            <el-table-column prop="name" label="设备名称"></el-table-column>
            <el-table-column prop="devtype" label="设备类型"></el-table-column>
            <el-table-column prop="startdata" label="开始数据"></el-table-column>
            <el-table-column prop="enddata" label="结束数据"></el-table-column>
            <el-table-column prop="rate" label="倍率"></el-table-column>
            <el-table-column prop="sum" label="该时间段内总能耗"></el-table-column>
            <el-table-column prop="location" label="安装位置"></el-table-column>
          </el-table>
        </div>
        <div class="data-page flex-row flex-justify-end flex-align-start">
          <el-pagination
            background
            layout="prev, pager, next"
            :total="tongjipage.form.totalpage"
            :current-page.sync="tongjipage.form.currpage"
            :page-size="tongjipage.form.pagesize"
            @current-change="handleTongjiPage">
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import ExcelJS from 'exceljs'
import saveAs from 'file-saver'
import { mapGetters } from 'vuex'
import {getChangqu, getLouhao, getLouCeng, getCompany, getMeterList, getSampleData, getNenghao, addMeterValue} from '@/api/engery.js'
export default {
  name: "EngerySample",
  data() {
    return {
      subindex: 1,
      lastsubindex: 1,
      mainpage: {
        form: {
          startTime: '',
          endTime: '',
          sampletype: '全部',
          devtype: '全部',
          sn: '',
          changqu: '全部',
          louhao: '',
          louceng: '',
          company: '',
          currpage: 1,
          pagesize: 15,
          totalpage: 10
        },
        startTime: null,
        endTime: null,
        options: {
          sampletype: [
            {
              value: '全部',
              label: '全部'
            },
            {
              value: '自动上传',
              label: '自动上传'
            },
            {
              value: '手工抄表',
              label: '手工抄表'
            }
          ],
          devtype: [
            {
              value: '全部',
              label: '全部'
            },
            {
              value: '电表',
              label: '电表'
            },
            {
              value: '水表',
              label: '水表'
            },
            {
              value: '冷气表',
              label: '冷气表'
            },
            {
              value: '流量计',
              label: '流量计'
            }
          ],
          changqu: [],
          louhao: [],
          louceng: [],
          company: []
        },
        tableData: []
      },
      manualpage: {
        form: {
          sn: '',
          name: '',
          devtype: '',
          location: '',
          value: '',
          manualuser: '',
          datetime: '',
          paratype: '手工抄表'
        },
        row: {}
      },
      shebeipage: {
        form: {
          changqu: '全部',
          louhao: '',
          louceng: '',
          devtype: '电表',
          currpage: 1,
          pagesize: 15,
          totalpage: 10
        },
        options: {
          devtype: [
            {
              value: '电表',
              label: '电表'
            },
            {
              value: '水表',
              label: '水表'
            },
            {
              value: '冷气表',
              label: '冷气表'
            },
            {
              value: '流量计',
              label: '流量计'
            }
          ],
        },
        tableData: []
      },
      tongjipage: {
        form: {
          currpage: 1,
          pagesize: 15,
          totalpage: 10
        },
        tableData: []
      }
    }
  },
  computed: {
    ...mapGetters([
      'getUserInfo'
    ])
  },
  async mounted() {
    const changqulist = await getChangqu()
    this.mainpage.options.changqu = changqulist.data
    const companyData = await getCompany()
    this.mainpage.options.company = companyData.data
    if(this.mainpage.options.company.length > 0) {
      this.mainpage.form.company = this.mainpage.options.company[0].value
    }
    const sampleData = await getSampleData(this.mainpage.form)
    this.mainpage.tableData = sampleData.data
  },
  methods: {
    async handleTongjiPage(value) {
      const response = await getNenghao(this.tongjipage.form, this.mainpage.form)
      this.tongjipage.tableData = response.data
    },
    async handleShebeiPage(value) {
      const response = await getMeterList(this.shebeipage.form)
      this.shebeipage.tableData = response.data
    },
    async handleShebeiSearch() {
      const response = await getMeterList(this.shebeipage.form)
      this.shebeipage.tableData = response.data
    },
    async handleMainPage(vaule) {
      await this.hadleMainSearch()
    },
    isNumber(str) {
      return /^[+-]?(\d+\.?\d*|\.\d+)$/.test(str);
    },
    async handleAddSg() {
      if(this.manualpage.form.sn == '') {
        this.$message.error('请选择表具')
        return
      }
      if(this.manualpage.form.value == '') {
        this.$message.error('表具数值不能为空')
        return
      }
      if(!this.isNumber(this.manualpage.form.value)) {
        this.$message.error('表具数值必须为数字')
        return
      }
      const result = await addMeterValue(this.manualpage.row.iid, this.manualpage.form)
      if(result.id) {
        this.$message.success('手工录入成功')
        this.changeSubindex(1)
        await this.hadleMainSearch()
      } else {
        this.$message.error('手工录入失败')
      }
    },
    async changeSubindex(index) {
      this.lastsubindex = this.subindex
      this.subindex = index
      if(index == 2 && this.lastsubindex == 1) {
        this.manualpage.form.sn = ''
        this.manualpage.form.name = ''
        this.manualpage.form.devtype = ''
        this.manualpage.form.location = ''
        this.manualpage.form.value = ''
        const userInfo = this.getUserInfo
        this.manualpage.form.manualuser = userInfo.username
        const datetime = this.formatDateTime(new Date())
        this.manualpage.form.datetime = datetime.replace(/ /g, 'T')
      }
      else if(index == 3) {
        const response = await getMeterList(this.shebeipage.form)
        this.shebeipage.tableData = response.data
      }
      else if(index == 4) {
        if(this.mainpage.startTime != null) {
          const startTime = this.formatDateTime(this.mainpage.startTime, 0)
          this.mainpage.form.startTime = startTime.substr(0, 10)
        }
        if(this.mainpage.endTime != null) {
          const endTime = this.formatDateTime(this.mainpage.endTime, 0)
          this.mainpage.form.endTime = endTime.substr(0, 10)
        }
        this.tongjipage.form.currpage = 1
        const response = await getNenghao(this.tongjipage.form, this.mainpage.form)
        this.tongjipage.tableData = response.data
      }
    },
    saveSample() {
      const workbook = new ExcelJS.Workbook()
      const sheet = workbook.addWorksheet('抄表管理')
      sheet.addRow(['序号', '设备编号', '设备名称', '设备类型', '上次抄表数', '本次抄表数', '本次用量', '安装位置', '所属公司(占比)', '抄表时间', '抄表类型', '抄表人']).font = { bold: true }
      for(var i = 0;i < this.mainpage.tableData.length;i++) {
        let temp = []
        temp.push(this.mainpage.tableData[i].id)
        temp.push(this.mainpage.tableData[i].sn)
        temp.push(this.mainpage.tableData[i].name)
        temp.push(this.mainpage.tableData[i].devtype)
        temp.push(this.mainpage.tableData[i].lastvalue)
        temp.push(this.mainpage.tableData[i].thisvalue)
        temp.push(this.mainpage.tableData[i].usevalue)
        temp.push(this.mainpage.tableData[i].location)
        temp.push(this.mainpage.tableData[i].company)
        temp.push(this.mainpage.tableData[i].datetime)
        temp.push(this.mainpage.tableData[i].paratype)
        temp.push(this.mainpage.tableData[i].parafrom)
        sheet.addRow(temp)
      }
      // sheet.columns = [
      //   { header: '序号', key: 'id', width: 20 },
      // ]
      workbook.xlsx.writeBuffer().then(buffer => {
        const blob = new Blob([buffer], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        })
        const datetime = this.formatDateTime(new Date()).replace(/[\s:-]/g, '')
        const fileName = '抄表管理' + datetime + '.xlsx'
        saveAs(blob, fileName)
      })
    },
    saveTongji() {
      const workbook = new ExcelJS.Workbook()
      const sheet = workbook.addWorksheet('能耗统计')
      sheet.addRow(['序号', '设备编号', '设备名称', '设备类型', '开始数据', '结束数据', '倍率', '该时段内总能耗', '安装位置']).font = { bold: true }
      for(var i = 0;i < this.tongjipage.tableData.length;i++) {
        let temp = []
        temp.push(this.tongjipage.tableData[i].id)
        temp.push(this.tongjipage.tableData[i].sn)
        temp.push(this.tongjipage.tableData[i].name)
        temp.push(this.tongjipage.tableData[i].devtype)
        temp.push(this.tongjipage.tableData[i].startdata)
        temp.push(this.tongjipage.tableData[i].enddata)
        temp.push(this.tongjipage.tableData[i].rate)
        temp.push(this.tongjipage.tableData[i].sum)
        temp.push(this.tongjipage.tableData[i].location)
        sheet.addRow(temp)
      }
      workbook.xlsx.writeBuffer().then(buffer => {
        const blob = new Blob([buffer], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        })
        const datetime = this.formatDateTime(new Date()).replace(/[\s:-]/g, '')
        const fileName = '能耗统计' + datetime + '.xlsx'
        saveAs(blob, fileName)
      })
    },
    async handleChangqu(value) {
      this.mainpage.form.louhao = ''
      this.mainpage.options.louhao = []
      this.mainpage.form.louceng = ''
      this.mainpage.options.louceng = []
      if(value == '全部') {
        return
      }
      const result = this.mainpage.options.changqu.filter(item => item.value == value)
      if(result.length == 0) return
      const response = await getLouhao(result[0].park_id)
      if(response.data.length <= 1) {
        this.mainpage.form.louhao = ''
        this.mainpage.options.louhao = []
        this.mainpage.form.louceng = ''
        this.mainpage.options.louceng = []
        return
      }
      this.mainpage.options.louhao = response.data
      if(this.mainpage.options.louhao.length > 0) {
        if(this.subindex == 1) {
          this.mainpage.form.louhao = this.mainpage.options.louhao[0].value
        }
        else if(this.subindex == 3){
          this.shebeipage.form.louhao = this.mainpage.options.louhao[0].value
        }
      }
    },
    async handleLouhao(value) {
      this.mainpage.form.louceng = ''
      this.mainpage.options.louceng = []
      if(value == '全部') {
        return
      }
      const result = this.mainpage.options.louhao.filter(item => item.value == value)
      if(result.length == 0) return
      const response = await getLouCeng(result[0].building_id)
      if(response.data.length <= 1) {
        this.mainpage.form.louceng = ''
        this.mainpage.options.louceng = []
        return
      }
      this.mainpage.options.louceng = response.data
      if(this.mainpage.options.louceng.length > 0) {
        if(this.subindex == 1) {
          this.mainpage.form.louceng = this.mainpage.options.louceng[0].value
        }
        else if(this.subindex == 3){
          this.shebeipage.form.louceng = this.mainpage.options.louhao[0].value
        }
      }
    },
    formatDateTime(now) {
      const padZero = n => n < 10 ? `0${n}` : n
      const year = now.getFullYear()
      const month = padZero(now.getMonth() + 1)
      const day = padZero(now.getDate())
      const hour = padZero(now.getHours())
      const minute = padZero(now.getMinutes())
      const second = padZero(now.getSeconds())
      const formatDate = `${year}-${month}-${day} ${hour}:${minute}:${second}`
      return formatDate
    },
    handleCheck(param) {
      this.manualpage.form.sn = param.sn
      this.manualpage.form.name = param.name
      this.manualpage.form.devtype = param.devtype
      this.manualpage.form.location = param.location
      this.manualpage.row = param
      this.changeSubindex(2)
    },
    async hadleMainSearch() {
      if(this.mainpage.startTime != null) {
        const startTime = this.formatDateTime(this.mainpage.startTime, 0)
        this.mainpage.form.startTime = startTime.substr(0, 10)
      }
      if(this.mainpage.endTime != null) {
        const endTime = this.formatDateTime(this.mainpage.endTime, 0)
        this.mainpage.form.endTime = endTime.substr(0, 10)
      }
      const sampleData = await getSampleData(this.mainpage.form)
      this.mainpage.tableData = sampleData.data
    }
  }
}
</script>

<style scoped>
.container {
  width: 100%;
  height: 100%;
}
.data-sample {
  width: 99%;
}
.data-search {
  width: 100%;
  background-color: #fff;
  box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.4);
  padding-top: 10px;
  padding-bottom: 10px;
  margin-top: 10px;
}
.ds-item {
  margin-left: 20px;
  margin-top: 10px;
  padding-left: 10px;
  padding-right: 10px;
}
.dsi-text {
  font-family: 'Arial';
  font-size: 16px;
  min-width: 140px;
  text-align: left;
}
.data-display {
  width: 100%;
  background-color: #fff;
  box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.4);
  margin-top: 20px;
  padding-bottom: 20px;
}
.data-bs {
  width: 100%;
  margin-top: 20px;
  text-align: left;
}
.gird-area {
  margin-top: 20px;
  margin-bottom: 20px;
  width: 98%;
}
.data-page {
  width: 98%;
}
.hhead {
  width: 100%;
  font-family: 'Arial';
  font-size: 16px;
  background-color: #fff;
  box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.4);
  padding: 10px;
}
.hheadl {
  width: 50%;
  margin-left: 10px;
}
.hheadr {
  width: 50%;
  margin-right: 10px;
}
.luru-display {
  width: 100%;
  background-color: #fff;
  box-shadow: 0px 0.5px 0.5px 0.5px rgba(0, 0, 0, 0.4);
  padding-bottom: 20px;
}
</style>
